import type { CodeNavRequestMessage } from './types.js';

export type CodeNavOpContext = {
  msg: CodeNavRequestMessage;
  reqPath: string;
  sessionParentPath: string;
  line: number;
  column: number;
};

export function normalizeCodeNavOp(op: CodeNavRequestMessage['op']): CodeNavRequestMessage['op'] {
  if (op === 'references' || op === 'symbols' || op === 'definitions') return op;
  return 'definition';
}
